import { ApiService } from 'src/app/shared/services/api.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';

import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-login-mobile',
    templateUrl: './login-mobile.component.html',
    styleUrls: ['./login-mobile.component.scss']
})
export class LoginMobileComponent implements OnInit {

    loginToken = ''
    flagLogin = false
    loginForm: FormGroup;
    submitted = false;
    returnUrl: string;
    constructor(

        private translateService: TranslateService,
        private commonService: CommonService,
        private apiService: ApiService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        public authFackservice: AuthfakeauthenticationService

    ) {
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.loginToken = params['loginToken'];
        });
        this.beforeLogin()
        document.body.removeAttribute('data-layout');
        document.body.classList.add('auth-body-bg');
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    selectedText: string = 'Xác Nhận Liên Kết';

    updateContent(text: string) {
        this.selectedText = text;
    }
    beforeLogin() {
        this.authFackservice.loginMobile(this.loginToken)
            .pipe(first())
            .subscribe(
                data => {
                    if (data && data['data'].role === 'admin') {
                        this.router.navigate(['/viettel/dashboard']);
                    } else {
                        if (data['data'].is_workspace === 1) {
                            this.router.navigate(['/account/workspace-mobile']);
                        } else {
                            this.router.navigate(['/account/landing-page']);
                        }
                    }
                    this.commonService.flagLogin = false;
                },
                error => {
                    this.handleLinkClick()

                    this.flagLogin = true
                    this.commonService.flagLogin = true;
                }
            );
    }
    handleLinkClick() {
        this.authFackservice.handlerLink(this.loginToken)
            .pipe(first())
            .subscribe(
                data => {
                    if (data && data['data'].role === 'admin') {
                        this.router.navigate(['/']);
                    } else {
                        if (data['data'].is_workspace === 1) {
                            this.router.navigate(['/account/workspace-mobile']);
                        } else {
                            this.router.navigate(['/account/landing-page']);
                        }
                    }

                },
                error => {
                    this.apiService.showToastMobile('error', ('Phiên đăng nhập hết hạn'))
                });
    }
    toLogin() {
        return this.router.navigate(['/account/login-account']);
    }
    onBack() {
        Swal.fire({
            // title: this.translateService.instant('FORM.Warning'),
            text: this.translateService.instant('Bạn có chắc chắn đóng ứng dụng?'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#141ED2',
            cancelButtonColor: 'fff',
            confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
            cancelButtonText: this.translateService.instant('FORM.Cancel'),
        }).then(result => {
          if (result.value) {
            this.authFackservice.logoutMobile();
    
            setTimeout(() => {
              if (window['ReactNativeWebView']) {
                window['ReactNativeWebView'].postMessage(JSON.stringify({
                  type: 'GO_BACK',
                }));
                console.log('Message posted to React Native WebView');
              } else {
                console.warn('ReactNativeWebView không tồn tại. Sử dụng môi trường local để test.');
                window['ReactNativeWebView'] = {
                  postMessage: (message) => {
                    console.log('Message posted to React Native (mock):', message);
                  }
                };
                window['ReactNativeWebView'].postMessage(JSON.stringify({
                  type: 'GO_BACK',
                }));
              }
            }, 2000);
          }
        });
    
      }
}

